// import { useEffect, useMemo, useState } from "react";
// import PropTypes from "prop-types";
// import Card from "@mui/material/Card";
// import Icon from "@mui/material/Icon";
// import Button from "@mui/material/Button";
// import Divider from "@mui/material/Divider";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
// import Select from "@mui/material/Select";
// import MenuItem from "@mui/material/MenuItem";
// import { useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { setIsVehicle } from "../../../features/vehicle/vehicleSlice";
// import { v4 as uuidv4 } from "uuid";
// import axios from "axios";
// import { catchmentJourneyGetData } from "features/catchmentJourney/catchmntthunk";
// import { setSelectedJourneyId } from "features/catchmentJourney/catchmentSlice";

// import { setAutoLoadRoute, setFleetStats } from "../../../features/vehicle/vehicleSlice";

// import {
//   setModalVisible,
//   setModelThing,
// } from "features/planning/planningSlice";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton, Tooltip
// } from "@mui/material";

// function Projects({ onVehicleSelect }) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // 👇 GETTING DATA DIRECTLY FROM REDUX
//   const {
//     myThings,
//     latestUpdates,
//     searchQuery,
//     activeFilter,
//     selectedVehicleNumber
//   } = useSelector((state) => state.fleet || {});

//   const responsedata = useMemo(() => ({
//     myThings: myThings || {},
//     latestUpdates: latestUpdates || {}
//   }), [myThings, latestUpdates]);


//   const things = useSelector((state) => state.things.filterThing || []);
//   const thempThing = things.find((e) => e.id === searchQuery) || {};

//   const [lastFetchedId, setLastFetchedId] = useState(null);
//   const { journeys, loading: loadingJourneys, selectedJourneyId } = useSelector((state) => state.catchmentData);

//   // === API Key Modal States ===
//   const [apiModalOpen, setApiModalOpen] = useState(false);
//   const [apiStep, setApiStep] = useState("confirm");
//   const [hours, setHours] = useState(0);
//   const [minutes, setMinutes] = useState(5);
//   const [tempLink, setTempLink] = useState("");
//   const [tempApiKey, setTempApiKey] = useState("");
//   const [loading, setLoading] = useState(false);

//   // === Live Streaming Modal States (Only View - No Create) ===
//   const [streamModalOpen, setStreamModalOpen] = useState(false);
//   const [currentVehicleForStream, setCurrentVehicleForStream] = useState("");
//   const [activeCameras, setActiveCameras] = useState([]);
//   const [loadingStreams, setLoadingStreams] = useState(false);
//   const [selectedCameras, setSelectedCameras] = useState([]);
//   const [gridSize, setGridSize] = useState(4);
//   const [showActiveOnly, setShowActiveOnly] = useState(false);
//   const [streamingAction, setStreamingAction] = useState({ loading: false, id: null });
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", color: "success" });

//   const toggleCameraSelection = (streamId) => {
//     setSelectedCameras((prev) =>
//       prev.includes(streamId) ? prev.filter((id) => id !== streamId) : [...prev, streamId]
//     );
//   };

//   useEffect(() => {
//     if (streamModalOpen && activeCameras.length > 0) {
//       setSelectedCameras(activeCameras.map((cam) => cam.streamId));
//       setGridSize(activeCameras.length <= 4 ? activeCameras.length : 4);
//     }
//   }, [streamModalOpen, activeCameras]);

//   const selectedThing = things.find((e) => e.id === searchQuery);
//   const hasTempLink = !!selectedVehicleNumber?.tempApiKey;

//   const API_BASE = "https://v3.dhundhoo.com";
//   const sessionToken = useSelector((state) => state.auth?.token || localStorage.getItem("token"));

//   const apiCall = async (url, method = "POST", body) => {
//     setLoading(true);
//     try {
//       // Ensure raw token is used
//       const cleanToken = sessionToken ? sessionToken.replace("Bearer ", "").trim() : "";

//       const response = await axios({
//         url: url.startsWith("http") ? url : `${API_BASE}${url}`,
//         method: method,
//         data: body,
//         headers: {
//           "x-dhundhoo-session": cleanToken,
//         },
//       });

//       // Axios stores the response in .data
//       const data = response.data;

//       // Check for "Internal Server Error" within a 200 response
//       if (data.message === "Internal Server Error" || data.error) {
//         throw new Error(data.message || "Backend processing failed");
//       }

//       return data;
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || err.message || "API Error";
//       alert(errorMsg);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

// const fetchActiveStreams = async (vehicleId) => {
//     setLoadingStreams(true);
//     setActiveCameras([]);

//     try {
//       const res = await axios.get("https://camera.dhundhoo.com/api/streams/broadcasting", {
//         headers: { "x-dhundhoo-session": sessionToken },
//       });

//       const data = res.data;

//       // Filter Bypass - Saare active streams dikhane ke liye
//       const vehicleStreams = data.filter((item) => item.streamId);

//       // 🔴 IMPORTANT: Hum original URL use kar rahe hain, bas autoplay aur mute laga rahe hain
//       // Browser bina mute ke videos ko apne aap play hone nahi deta
//       const autoPlayStreams = vehicleStreams.map(cam => {
//         let videoUrl = cam.embedUrl;

//         // Agar URL me already autoplay nahi likha hai, toh hum append kar denge
//         if (!videoUrl.includes("autoplay=true")) {
//           videoUrl = `${videoUrl}&autoplay=true&mute=true`;
//         }

//         return { ...cam, embedUrl: videoUrl };
//       });

//       setActiveCameras(autoPlayStreams);

//     } catch (err) {
//       console.error("Stream fetch error:", err);
//       setActiveCameras([]);
//     } finally {
//       setLoadingStreams(false);
//     }
//   };

// //  const fetchActiveStreams = async (vehicleId) => {
// //     setLoadingStreams(true);
// //     setActiveCameras([]);

// //     try {
// //       const res = await axios.get("https://camera.dhundhoo.com/api/streams/broadcasting", {
// //         headers: { "x-dhundhoo-session": sessionToken },
// //       });

// //       const data = res.data;

// //       console.log("📡 Total Streams from API:", data.length);

// //       // Filter Bypass kar diya hai -> Saare active streams array mein aayenge
// //       const vehicleStreams = data.filter((item) => {
// //         return item.streamId ? true : false;
// //       });

// //       console.log("✅ Bypassed Filter - Showing all streams:", vehicleStreams);

// //       // HTTP to HTTPS Converter (Taki browser Iframe ko block na kare)
// //       const secureStreams = vehicleStreams.map(cam => {
// //         let safeEmbedUrl = cam.embedUrl;

// //         if (window.location.protocol === "https:" && safeEmbedUrl.includes("http://")) {
// //             safeEmbedUrl = safeEmbedUrl.replace("http://", "https://").replace(":5080", ":5443");
// //         }

// //         return { ...cam, embedUrl: safeEmbedUrl };
// //       });

// //       setActiveCameras(secureStreams);

// //     } catch (err) {
// //       console.error("Stream fetch error:", err);
// //       setActiveCameras([]);
// //     } finally {
// //       setLoadingStreams(false);
// //     }
// //   };

//   const openLiveView = async (vehicleId) => {
//     setCurrentVehicleForStream(vehicleId);
//     setStreamModalOpen(true);
//     await fetchActiveStreams(vehicleId);
//   };

//   const handleCreateLink = async () => {
//     if (!selectedVehicleNumber) {
//       alert("Vehicle not selected");
//       return;
//     }

//     try {
//       const duration =
//         (parseInt(hours) || 0) * 60 +
//         (parseInt(minutes) || 0);

//       const generatedKey = uuidv4();

//       const payload = {
//         thingId: selectedVehicleNumber,
//         tempApiKey: generatedKey,
//         expireTimeInMinutes: duration,
//       };

//       const data = await apiCall(
//         "/tempUrl/save",
//         "POST",
//         payload
//       );

//       const weblink = `https://web.dhundhoo.com/live_temp?apiKey=${generatedKey}&thingId=${selectedVehicleNumber}`;

//       setTempLink(weblink);

//       setTempApiKey(generatedKey);

//       setTimeout(() => {
//         setApiStep("success");
//       }, 100);

//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleUpdateLink = async () => {
//     if (!tempApiKey || !selectedVehicleNumber) return;
//     try {
//       const duration = (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);

//       const payload = {
//         thingId: selectedVehicleNumber,
//         tempApiKey: tempApiKey,
//         expireTimeInMinutes: duration,
//       };

//       await apiCall("/tempUrl/update", "POST", payload);

//       // Generate the link for display (same as create logic)
//       const weblink = `https://web.dhundhoo.com/live_temp?apiKey=${tempApiKey}&thingId=${selectedVehicleNumber}`;

//       setTempLink(weblink);
//       // setApiStep("success");
//       setTimeout(() => {
//         setApiStep("success");
//       }, 100);
//       openSnackbar("Temporary URL updated successfully");
//     } catch (err) {
//       openSnackbar(err.message || "Failed to update URL", "error");
//     }
//   };

//   const handleDeleteLink = async () => {
//     if (!tempApiKey || !selectedVehicleNumber) return;
//     try {
//       const payload = {
//         thingId: selectedVehicleNumber,
//         tempApiKey,
//       };

//       await apiCall("https://camera.dhundhoo.com/tempUrl/delete", "POST", payload);
//       alert("Link deleted!");
//       setApiModalOpen(false);
//     } catch (err) { }
//   };

//   const handleDropdownOpen = () => {
//     if (!searchQuery) return;
//     if (searchQuery === lastFetchedId) return;

//     dispatch(catchmentJourneyGetData(searchQuery));
//     setLastFetchedId(searchQuery);
//     dispatch(setSelectedJourneyId(""));
//   };

//   useEffect(() => {
//     dispatch(setSelectedJourneyId(""));
//   }, [searchQuery, dispatch]);

//   const resetModal = () => {
//     setApiStep("confirm");
//     setHours(0);
//     setMinutes(30);
//     setTempLink("");
//     setTempApiKey("");
//   };

//   console.log("selected thingggg", searchQuery);


//   const openSnackbar = (message, color = "success") => {
//     setSnackbar({ open: true, message, color });
//   };

//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   const openApiModal = (action = "create") => {
//     resetModal();
//     if (action === "update" && selectedVehicleNumber?.tempApiKey) {
//       setTempApiKey(selectedVehicleNumber.tempApiKey);
//       setApiStep("time");
//     } else if (action === "delete" && selectedVehicleNumber?.tempApiKey) {
//       setTempApiKey(selectedVehicleNumber.tempApiKey);
//       setApiStep("delete");
//     }
//     setApiModalOpen(true);
//   };

//   // Inside Projects.js
//   const vehicles = useMemo(() => {
//     if (!responsedata || !responsedata.myThings) return [];

//     const myThings = responsedata.myThings || {};
//     const latestUpdates = responsedata.latestUpdates || {};
//     const now = Date.now();

//     return Object.entries(myThings)
//       .map(([vehicleNumber, data]) => {
//         const updateData = latestUpdates[vehicleNumber] || {};
//         const latest = updateData?.latest?.GPS || updateData?.latest?.MOBILE || {};
//         const raw = latest?.raw || {};
//         const updatedAt = latest?.updatedAt || data?.latest?.MOBILE?.updatedAt || null;

//         const journeyAvailable = data?.journeyAvailable === true;
//         const journeyData = data?.currentJourney || {};
//         const lastVisitedStopIndex = updateData?.lastVisitedStopIndex ?? 0;
//         const stops = data?.stops || {};
//         const totalStopsCount = Object.keys(stops).length;

//         const progress = totalStopsCount > 0
//           ? Math.min(Math.round((lastVisitedStopIndex / totalStopsCount) * 100), 100)
//           : 0;

//         // Extract values for filtering logic
//         const speed = parseFloat(latest?.speed ?? 0);
//         const ignitionValue = latest?.raw?.IGNITION?.toString() ?? "";
//         const isStale = updatedAt && (new Date(updatedAt).getTime() + 3600000 < now);

//         return {
//           vehicleNumber,
//           nickName: data?.thing?.nickName || "N/A",
//           ignition: latest?.ignition ?? data?.latest?.MOBILE?.ignition ? "ON" : "OFF",
//           ignitionRaw: ignitionValue, // for filtering
//           time: updatedAt ? new Date(updatedAt).toLocaleString("en-IN") : "N/A",
//           rawTime: updatedAt ? new Date(updatedAt).getTime() : 0,
//           speed: speed.toFixed(2),
//           isStale, // for filtering
//           signal: raw?.SIGNAL_STRENGTH ? parseFloat(raw.SIGNAL_STRENGTH).toFixed() : "0.0",
//           satellites: raw?.TOTAL_SATELLITE || 0,
//           tempThing: data?.thing?.tempThing || null,
//           journeyAvailable,
//           route: journeyAvailable ? `${journeyData?.journeyName || "N/A"}` : "N/A",
//           status: `${lastVisitedStopIndex} / ${totalStopsCount}`,
//           progress,
//         };
//       })
//       .filter((vehicle) => {
//         const q = (searchQuery || "").toLowerCase();
//         const actualSearch = q.startsWith("@") ? "" : q;

//         const matchesSearch = (vehicle.vehicleNumber || "").toLowerCase().includes(actualSearch) ||
//           (vehicle.nickName || "").toLowerCase().includes(actualSearch);

//         // If @total is active, we only care about the search match
//         if (activeFilter === "@total") {
//           return matchesSearch;
//         }

//         // Otherwise, filter by specific status
//         const speedNum = parseFloat(vehicle.speed);
//         let matchesStatus = false;

//         switch (activeFilter) {
//           case "@offline":
//             matchesStatus = vehicle.isStale;
//             break;
//           case "@running":
//             matchesStatus = !vehicle.isStale && vehicle.ignitionRaw === "1" && speedNum >= 0.25;
//             break;
//           case "@idle":
//             matchesStatus = !vehicle.isStale && vehicle.ignitionRaw === "1" && speedNum < 0.25;
//             break;
//           case "@parked":
//             matchesStatus = !vehicle.isStale && vehicle.ignitionRaw === "0";
//             break;
//           case "@onroute":
//             matchesStatus = vehicle.journeyAvailable;
//             break;
//           default:
//             matchesStatus = true;
//         }

//         return matchesStatus && matchesSearch;
//       })
//       .sort((a, b) => b.rawTime - a.rawTime);
//   }, [responsedata, searchQuery, activeFilter]); // Add activeFilter to dependencies

//   const filteredCameras = useMemo(() => {
//     if (!showActiveOnly) return activeCameras;
//     return activeCameras.filter((cam) => cam.status === "broadcasting");
//   }, [activeCameras, showActiveOnly]);

//   if (!responsedata || !responsedata.myThings) {
//     return (
//       <MDBox p={2}>
//         <MDTypography variant="h6">Loading vehicle data...</MDTypography>
//       </MDBox>
//     );
//   }

//   const getVehicleStatusColor = (ignition, speed, rawTime) => {
//     const now = Date.now();
//     const isStale = rawTime && rawTime + 3600000 < now;
//     if (isStale) return "secondary";
//     if (ignition === "OFF") return "error.main";
//     return parseFloat(speed) > 0 ? "success.main" : "warning.main";
//   };

//   const getSpeedStatusText = (ignition, speed, rawTime) => {
//     const spd = parseFloat(speed);
//     const now = Date.now();
//     const isStale = rawTime && rawTime + 3600000 < now;
//     if (isStale) return "Offline";
//     if (ignition === "OFF" && spd === 0) return "Parked";
//     if (ignition === "ON" && spd === 0) return "Idle";
//     if (ignition === "ON" && spd > 0) return "Running";
//     return "N/A";
//   };

//   const getSpeedTextColor = (ignition, speed, rawTime) => {
//     const spd = parseFloat(speed);
//     const now = Date.now();
//     const isStale = rawTime && rawTime + 3600000 < now;
//     if (isStale) return "secondary";
//     if (ignition === "OFF" && spd === 0) return "error";
//     if (ignition === "ON" && spd === 0) return "warning";
//     if (ignition === "ON" && spd > 0) return "success";
//     return "text";
//   };

//   const handleEditJourneys = () => {
//     if (searchQuery.trim() && !searchQuery.startsWith("@")) dispatch(setIsVehicle(searchQuery.trim()));
//     navigate("/Create/Journey");
//   };

//   const handleAssignReplacement = () => {
//     if (searchQuery.trim() && !searchQuery.startsWith("@")) dispatch(setIsVehicle(searchQuery.trim()));
//     const thing = things.find((e) => e.id === searchQuery);
//     dispatch(setModelThing(thing));
//     dispatch(setModalVisible(true));
//   };

//   const handleEditDetails = () => {
//     if (searchQuery.trim() && !searchQuery.startsWith("@")) dispatch(setIsVehicle(searchQuery.trim()));
//     navigate("/Create/Edit-Details");
//   };

//   const handleNotificationLogs = () => {
//     const vId = searchQuery.trim() && !searchQuery.startsWith("@") ? searchQuery.trim() : "";
//     if (vId) dispatch(setIsVehicle(vId));

//     navigate("/Reports/Notification-logs", { state: { autoFetchVehicleId: vId } });
//   };

//   const handleRouteReplay = () => {
//     if (searchQuery.trim() && !searchQuery.startsWith("@")) {
//       dispatch(setIsVehicle(searchQuery.trim()));
//       dispatch(setAutoLoadRoute(true));
//       navigate("/Route-Replay");
//     }
//   };

//   const handleCloseStreamModal = () => {
//     const camsToStop = [...activeCameras]; 
//     setStreamModalOpen(false);
//     setActiveCameras([]);
//     setSelectedCameras([]);

//     if (camsToStop.length > 0) {
//       camsToStop.forEach((cam) => {
//         axios.post(
//           `https://camera.dhundhoo.com/api/streams/stop/${cam.streamId}`,
//           {},
//           {
//             headers: {
//               "Content-Type": "application/json",
//               "x-dhundhoo-session": sessionToken || localStorage.getItem("token"),
//             },
//           }
//         ).catch((err) => console.error("Failed to stop stream:", err));
//       });
//     }
//   };

//   // const handleCloseStreamModal = async () => {
//   //   if (activeCameras.length === 0) {
//   //     setStreamModalOpen(false);
//   //     return;
//   //   }
//   //   try {
//   //     await Promise.all(
//   //       activeCameras.map(async (cam) => {
//   //         try {
//   //           await axios.post(
//   //             `https://camera.dhundhoo.com/api/streams/stop/${cam.streamId}`,
//   //             {},
//   //             {
//   //               headers: {
//   //                 "Content-Type": "application/json",
//   //                 "x-dhundhoo-session": localStorage.getItem("token"),
//   //               },
//   //             }
//   //           );
//   //         } catch (err) { }
//   //       })
//   //     );
//   //   } catch (err) {
//   //   } finally {
//   //     setStreamModalOpen(false);
//   //     setSelectedCameras([]);
//   //     setActiveCameras([]);
//   //   }
//   // };

//   const handleStartStream = async (streamId) => {
//     setStreamingAction({ loading: true, id: streamId });
//     try {
//       await axios.post(
//         `https://camera.dhundhoo.com/api/streams/start/${streamId}`,
//         {},
//         { headers: { "x-dhundhoo-session": sessionToken } }
//       );
//       alert("Stream started!");
//       await fetchActiveStreams(currentVehicleForStream);
//     } catch (err) {
//       alert("Failed to start stream");
//     } finally {
//       setStreamingAction({ loading: false, id: null });
//     }
//   };

//   const handleRestartStream = async (streamId) => {
//     if (!window.confirm("Restart this stream?")) return;
//     setStreamingAction({ loading: true, id: streamId });
//     try {
//       await axios.post(
//         `https://camera.dhundhoo.com/api/streams/restart/${streamId}`,
//         {},
//         { headers: { "x-dhundhoo-session": sessionToken } }
//       );
//       alert("Stream restarted!");
//       await fetchActiveStreams(currentVehicleForStream);
//     } catch (err) {
//       alert("Restart failed");
//     } finally {
//       setStreamingAction({ loading: false, id: null });
//     }
//   };

//   const handleStopStream = async (streamId) => {
//     if (!window.confirm("Stop this stream?")) return;
//     setStreamingAction({ loading: true, id: streamId });
//     try {
//       await axios.post(
//         `https://camera.dhundhoo.com/api/streams/stop/${streamId}`,
//         {},
//         { headers: { "x-dhundhoo-session": sessionToken } }
//       );
//       alert("Stream stopped!");
//       await fetchActiveStreams(currentVehicleForStream);
//     } catch (err) {
//       alert("Stop failed");
//     } finally {
//       setStreamingAction({ loading: false, id: null });
//     }
//   };

//   const handleDeleteStream = async (streamId) => {
//     if (!window.confirm("Delete this stream permanently?")) return;
//     setStreamingAction({ loading: true, id: streamId });
//     try {
//       await axios.delete(`/api/streams/delete/${streamId}`, {
//         headers: { "x-dhundhoo-session": sessionToken },
//       });
//       alert("Stream deleted!");
//       await fetchActiveStreams(currentVehicleForStream);
//     } catch (err) {
//       alert("Delete failed");
//     } finally {
//       setStreamingAction({ loading: false, id: null });
//     }
//   };

//   const renderVehicleCard = (vehicle) => (
//     <Card
//       key={vehicle.vehicleNumber}
//       sx={{
//         mb: 2,
//         p: 2,
//         cursor: "pointer",
//         "&:hover": { boxShadow: 3 },
//       }}
//       onClick={() => onVehicleSelect(vehicle.vehicleNumber)}
//     >
//       <MDBox display="flex" justifyContent="space-between" alignItems="center">
//         <MDBox display="flex" flexDirection="column" width="100%">
//           <MDTypography
//             variant="h6"
//             fontWeight="medium"
//             display="flex"
//             alignItems="center"
//             gap={1}
//             flexWrap="wrap"
//           >
//             <DirectionsBusIcon
//               fontSize="small"
//               sx={{
//                 color: getVehicleStatusColor(
//                   vehicle.ignition,
//                   vehicle.speed,
//                   vehicle.rawTime
//                 ),
//               }}
//             />
//             <MDTypography
//               component="span"
//               variant="body1"
//               fontWeight="bold"
//               sx={{ fontSize: "0.85rem" }}
//             >
//               {vehicle.nickName}
//             </MDTypography>{" "}
//             <MDTypography
//               component="span"
//               variant="body2"
//               color="text.secondary"
//               sx={{ fontSize: "0.75rem" }}
//             >
//               {vehicle.vehicleNumber}
//             </MDTypography>
//             <MDBox display="flex" alignItems="center" gap={1} ml="auto">
//               {vehicle.tempThing && (
//                 <MDTypography fontWeight="small" fontSize="0.60rem" color="secondary">
//                   Replacement{" "}
//                   <MDTypography component="span" color="error" fontSize="0.60rem" fontWeight="bold">
//                     {vehicle.tempThing}
//                   </MDTypography>
//                 </MDTypography>
//               )}
//               <Tooltip title={hasTempLink ? "Update Link" : "Create Link"}>
//                 <IconButton
//                   size="small"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     openApiModal(hasTempLink ? "update" : "create");
//                   }}
//                   sx={{
//                     color: hasTempLink ? "primary.main" : "text.secondary",
//                   }}
//                 >
//                   <Icon fontSize="small">link</Icon>
//                 </IconButton>
//               </Tooltip>

//               {localStorage.getItem("isLiveCamera") === "true" && (
//                 <Button
//                   variant="contained"
//                   size="small"
//                   color="error"
//                   startIcon={<Icon>live_tv</Icon>}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     openLiveView(vehicle.vehicleNumber);
//                   }}
//                   sx={{ fontWeight: "bold" }}
//                 >
//                   LIVE VIEW
//                 </Button>
//               )}
//             </MDBox>
//           </MDTypography>

//           <Divider sx={{ my: 1 }} />

//           <MDBox display="flex" alignItems="center" justifyContent="space-between" width="100%">
//             <MDTypography variant="button" color="text">
//               {vehicle.time}
//             </MDTypography>
//             <MDTypography
//               variant="button"
//               color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)}
//               fontWeight="medium"
//               display="flex"
//               alignItems="center"
//               gap={0.5}
//             >
//               <Icon fontSize="small">speed</Icon>
//               {(vehicle.speed * 3.6).toFixed(2)} km/hr
//               {getSpeedStatusText(vehicle.ignition, vehicle.speed, vehicle.rawTime)}
//             </MDTypography>
//           </MDBox>
//         </MDBox>
//       </MDBox>

//       <MDBox mt={1.5} display="flex" alignItems="flex-start" gap={3}>
//         <MDTypography variant="button" color="text">
//           <Icon fontSize="small" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)}>
//             power
//           </Icon>
//           Ignition {vehicle.ignition}
//         </MDTypography>
//         <MDTypography variant="button" color="text">
//           <Icon fontSize="small">signal_cellular_alt</Icon> Signal {vehicle.signal}%
//         </MDTypography>
//         <MDTypography variant="button" color="text">
//           <Icon fontSize="small">satellite_alt</Icon> Satellites {vehicle.satellites}
//         </MDTypography>
//       </MDBox>

//       {selectedVehicleNumber !== undefined && searchQuery === vehicle.vehicleNumber && (
//         <MDBox sx={{ padding: 1 }}>
//           <Select
//             value={selectedJourneyId}
//             onOpen={handleDropdownOpen}
//             onChange={(e) => dispatch(setSelectedJourneyId(e.target.value))}
//             displayEmpty
//             renderValue={(selected) => {
//               if (!selected) return "Select and plot journey route on map";
//               const j = journeys.find((item) => item.journeyId === selected);
//               return j ? j.journeyName : "Select Journey";
//             }}
//             sx={{ width: "100%", mb: 2, p: 1, fontSize: "0.875rem" }}
//           >
//             {loadingJourneys ? (
//               <MenuItem disabled><MDTypography variant="button">Loading...</MDTypography></MenuItem>
//             ) : journeys.length === 0 ? (
//               <MenuItem disabled><MDTypography variant="button">No journeys found</MDTypography></MenuItem>
//             ) : (
//               journeys.map((item) => (
//                 <MenuItem key={item.journeyId} value={item.journeyId}>
//                   <MDBox display="flex" flexDirection="column">
//                     <MDTypography variant="button" fontWeight="bold">{item.journeyName}</MDTypography>
//                     <MDTypography variant="caption" color="text">{item.type} - {item.startTime}</MDTypography>
//                   </MDBox>
//                 </MenuItem>
//               ))
//             )}
//           </Select>

//           <MDBox sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//             <Button variant="outlined" onClick={handleEditDetails} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
//               Edit Details
//             </Button>
//             <Button variant="outlined" onClick={handleRouteReplay} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
//               Route Replay
//             </Button>
//             <Button variant="outlined" onClick={handleEditJourneys} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
//               Edit Journeys
//             </Button>
//             <Button variant="outlined" onClick={handleNotificationLogs} sx={{ fontWeight: 400, border: "1px solid #ccc", color: "rgb(102, 102, 102)" }}>
//               Notification Logs
//             </Button>
//             <Button variant="outlined" onClick={handleAssignReplacement} sx={{ color: thempThing.tempThing ? "red" : "rgb(102, 102, 102)", border: thempThing.tempThing ? "1px solid red" : "1px solid #ccc" }}>
//               {thempThing.tempThing ? "Remove Replacement" : "Assign Replacement"}
//             </Button>

//             {hasTempLink && (
//               <Button variant="outlined" color="error" startIcon={<Icon>delete</Icon>} onClick={(e) => { e.stopPropagation(); openApiModal("delete"); }}>
//                 Delete Link
//               </Button>
//             )}
//           </MDBox>
//         </MDBox>
//       )}


//       {vehicle.journeyAvailable ? (
//         <>
//           <Divider sx={{ my: 1 }} />
//           <MDTypography variant="button" fontWeight="medium" color="text">
//             On Route <strong>{vehicle.route}</strong>
//           </MDTypography>
//           <MDTypography variant="button" color="success">
//             Status: {vehicle.status}
//           </MDTypography>
//           <MDBox mt={1}>
//             <div style={{ width: '100%', backgroundColor: '#f0f2f5', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
//               <div style={{ width: `${vehicle.progress}%`, backgroundColor: '#4caf50', height: '100%', borderRadius: '4px', transition: 'width 0.5s ease-in-out' }} />
//             </div>
//           </MDBox>
//         </>
//       ) : (
//         <Divider sx={{ my: 1 }} />
//       )}
//     </Card>
//   );

//   return (
//     <MDBox pb={3} sx={{ maxHeight: { xs: 300, md: 630 }, overflowY: "auto", scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}>
//       {vehicles.map(renderVehicleCard)}

//       {/* <Dialog open={apiModalOpen} onClose={() => setApiModalOpen(false)} maxWidth="sm" fullWidth> */}
//       <Dialog
//         open={apiModalOpen}
//         onClose={() => {
//           if (!loading) {
//             setApiModalOpen(false);
//           }
//         }}
//         maxWidth="sm"
//         fullWidth
//       >
//         {/* (Modal content as is) */}
//         <DialogTitle>
//           {apiStep === "confirm" && "Create API Key"}
//           {apiStep === "time" && (tempApiKey ? "Update Link" : "Select Expiry Time")}
//           {apiStep === "success" && "Link Generated"}
//           {apiStep === "delete" && "Delete Temp URL Link"}
//           <IconButton
//             onClick={() => setApiModalOpen(false)}
//             sx={{ position: "absolute", right: 8, top: 8 }}
//           >
//             <Icon>close</Icon>
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           {apiStep === "confirm" && (
//             <MDTypography>Are you sure you want to create an API key?</MDTypography>
//           )}

//           {apiStep === "time" && (
//             <MDBox display="flex" alignItems="center" gap={2} flexWrap="wrap">
//               <Select value={hours} onChange={(e) => setHours(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
//                 {[...Array(25)].map((_, i) => (
//                   <MenuItem key={i} value={i}>
//                     {i} hours
//                   </MenuItem>
//                 ))}
//               </Select>
//               <Select value={minutes} onChange={(e) => setMinutes(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
//                 {Array.from({ length: 60 }, (_, i) => (
//                   <MenuItem key={i} value={i}>
//                     {i} minutes
//                   </MenuItem>
//                 ))}
//               </Select>
//               <Button
//                 variant="contained"
//                 disabled={loading}
//                 onClick={async (e) => {
//                   e.preventDefault();
//                   e.stopPropagation();

//                   if (loading) return;

//                   try {
//                     if (tempApiKey) {
//                       await handleUpdateLink();
//                     } else {
//                       await handleCreateLink();
//                     }
//                   } catch (err) {
//                     console.error(err);
//                   }
//                 }}
//                 sx={{
//                   background: "#FB8C00",
//                   color: "#fff",
//                   minWidth: 120,
//                   height: 40,
//                   "&:hover": {
//                     background: "#ef6c00",
//                   },
//                 }}
//               >
//                 {loading ? "Please Wait..." : "Confirm"}
//               </Button>
//             </MDBox>
//           )}

//           {apiStep === "success" && (
//             <MDBox>
//               <MDTypography variant="body2">Generated Link:</MDTypography>
//               <MDBox
//                 sx={{
//                   bgcolor: "#f5f5f5",
//                   p: 1.5,
//                   borderRadius: 1,
//                   wordBreak: "break-all",
//                   fontFamily: "monospace",
//                 }}
//               >
//                 {tempLink}
//               </MDBox>
//               <MDBox display="flex" gap={1} mt={2}>
//                 <Button
//                   variant="contained"
//                   startIcon={<Icon>content_copy</Icon>}
//                   onClick={() => {
//                     navigator.clipboard.writeText(tempLink);
//                     // alert("Copied!");
//                     openSnackbar("Copied!")
//                   }}
//                   style={{ background: "#FB8C00", color: 'white' }}
//                 >
//                   Copy
//                 </Button>
//                 <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: "#FB8C00", color: 'white' }}>
//                   Update
//                 </Button>
//                 <Button variant="contained" color="error" onClick={() => setApiStep("delete")} style={{ background: "#FB8C00", color: 'white' }}>
//                   Delete
//                 </Button>
//               </MDBox>
//             </MDBox>
//           )}

//           {apiStep === "delete" && (
//             <MDTypography color="error">Are you sure you want to delete this temporary link?</MDTypography>
//           )}
//         </DialogContent>

//         <DialogActions>
//           {apiStep === "confirm" && (
//             <>
//               <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
//               <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: '#FB8C00', color: 'white' }}>
//                 OK
//               </Button>
//             </>
//           )}
//           {apiStep === "delete" && (
//             <>
//               <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
//               <Button variant="contained" color="error" onClick={handleDeleteLink}>
//                 Delete
//               </Button>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>
//       {/* --- STREAM LIVE VIEW MODAL --- */}
//       <Dialog
//         open={streamModalOpen}
//         onClose={handleCloseStreamModal}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>
//           Live View - {currentVehicleForStream}
//           <IconButton
//             onClick={handleCloseStreamModal}
//             sx={{ position: "absolute", right: 8, top: 8 }}
//           >
//             <Icon>close</Icon>
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers sx={{ background: "#1e1e1e", minHeight: "300px" }}>
//           {loadingStreams ? (
//             <MDBox display="flex" justifyContent="center" alignItems="center" height="100%">
//               <MDTypography color="white">Loading live streams...</MDTypography>
//             </MDBox>
//           ) : activeCameras.length === 0 ? (
//             <MDBox display="flex" justifyContent="center" alignItems="center" height="100%">
//               <MDTypography color="white">No active broadcasts found for this vehicle.</MDTypography>
//             </MDBox>
//           ) : (
//             <MDBox 
//               display="grid" 
//               gridTemplateColumns={{ xs: "1fr", md: activeCameras.length > 1 ? "1fr 1fr" : "1fr" }} 
//               gap={2}
//             >
//               {activeCameras.map((cam) => (
//                 <MDBox key={cam.streamId} sx={{ width: "100%", background: "#000", borderRadius: 2, overflow: "hidden" }}>
//                   <MDBox p={1} bgcolor="#333" display="flex" justifyContent="space-between">
//                     <MDTypography variant="caption" color="white" fontWeight="bold">
//                       {cam.streamId}
//                     </MDTypography>
//                     <MDTypography variant="caption" color={cam.status === "broadcasting" ? "success" : "error"}>
//                       ● {cam.status.toUpperCase()}
//                     </MDTypography>
//                   </MDBox>

//                   {/* 👇 Yahan iframe ke through embedUrl play ho raha hai */}
//                   <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
//                     <iframe
//                       src={cam.embedUrl}
//                       frameBorder="0"
//                       allow="autoplay; fullscreen"
//                       allowFullScreen
//                       style={{
//                         position: "absolute",
//                         top: 0,
//                         left: 0,
//                         width: "100%",
//                         height: "100%",
//                       }}
//                     />
//                   </div>
//                 </MDBox>
//               ))}
//             </MDBox>
//           )}
//         </DialogContent>
//       </Dialog>
//     </MDBox>
//   );
// }

// Projects.propTypes = {
//   onVehicleSelect: PropTypes.func,
// };

// export default Projects;


import { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setIsVehicle } from "../../../features/vehicle/vehicleSlice";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import PlaybackHistoryModal from "./PlaybackHistoryModal";
import { catchmentJourneyGetData } from "features/catchmentJourney/catchmntthunk";
import { setSelectedJourneyId } from "features/catchmentJourney/catchmentSlice";
import { setAutoLoadRoute,setRouteReplayVehicle } from "../../../features/vehicle/vehicleSlice";
import { setModalVisible, setModelThing } from "features/planning/planningSlice";
import { useMaterialUIController } from "context";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Tooltip } from "@mui/material";

// 👇 IMPORT YOUR NEW COMPONENT HERE (Update the path accordingly)
import LiveCameraModal from "./LiveCameraModal";

function Projects({ onVehicleSelect }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 👇 GETTING DATA DIRECTLY FROM REDUX
  const {
    myThings,
    latestUpdates,
    searchQuery,
    activeFilter,
    selectedVehicleNumber
  } = useSelector((state) => state.fleet || {});

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const responsedata = useMemo(() => ({
    myThings: myThings || {},
    latestUpdates: latestUpdates || {}
  }), [myThings, latestUpdates]);

  const things = useSelector((state) => state.things.filterThing || []);
  const thempThing = things.find((e) => e.id === searchQuery) || {};

  const [lastFetchedId, setLastFetchedId] = useState(null);
  const { journeys, loading: loadingJourneys, selectedJourneyId } = useSelector((state) => state.catchmentData);

  // === API Key Modal States ===
  const [apiModalOpen, setApiModalOpen] = useState(false);
  const [apiStep, setApiStep] = useState("confirm");
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(5);
  const [tempLink, setTempLink] = useState("");
  const [tempApiKey, setTempApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", color: "success" });

  // === Live Streaming Wrapper States ===
  const [streamModalOpen, setStreamModalOpen] = useState(false);
  const [currentVehicleForStream, setCurrentVehicleForStream] = useState("");
  const [currentImeiForStream, setCurrentImeiForStream] = useState("");

  const [playbackModalOpen, setPlaybackModalOpen] = useState(false);
  const [currentVehicleForPlayback, setCurrentVehicleForPlayback] = useState("");
  const [currentImeiForPlayback, setCurrentImeiForPlayback] = useState(""); // 👈 Nayi state add karo

  const selectedThing = things.find((e) => e.id === searchQuery);
  const hasTempLink = !!selectedVehicleNumber?.tempApiKey;
  const [linkTargetVehicle, setLinkTargetVehicle] = useState(null);

  const API_BASE = "https://v3.dhundhoo.com";
  const sessionToken = useSelector((state) => state.auth?.token || localStorage.getItem("token"));

  const apiCall = async (url, method = "POST", body) => {
    setLoading(true);
    try {
      const cleanToken = sessionToken ? sessionToken.replace("Bearer ", "").trim() : "";
      const response = await axios({
        url: url.startsWith("http") ? url : `${API_BASE}${url}`,
        method: method,
        data: body,
        headers: { "x-dhundhoo-session": cleanToken },
      });

      const data = response.data;
      if (data.message === "Internal Server Error" || data.error) {
        throw new Error(data.message || "Backend processing failed");
      }
      return data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.message || "API Error";
      alert(errorMsg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const openLiveView = (vehicleId, imei) => {

    console.log("Live View Clicked -> Vehicle ID:", vehicleId, "| IMEI:", imei);

    setCurrentVehicleForStream(vehicleId);
    setCurrentImeiForStream(imei);
    setStreamModalOpen(true);
  };

  // const openPlaybackView = (vehicleId) => {
  //   setCurrentVehicleForPlayback(vehicleId);
  //   setPlaybackModalOpen(true);
  // };

  const openPlaybackView = (vehicleId, imei) => {
    setCurrentVehicleForPlayback(vehicleId);
    setCurrentImeiForPlayback(imei); // 👈 IMEI set kar rahe hain payload ke liye
    setPlaybackModalOpen(true);
  };

  const handleCreateLink = async () => {
    if (!linkTargetVehicle) return alert("Vehicle not selected");

    try {
      const duration = (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);
      const generatedKey = uuidv4();

      const payload = {
        thingId: linkTargetVehicle,        // 👈 changed
        tempApiKey: generatedKey,
        expireTimeInMinutes: duration,
      };

      await apiCall("/tempUrl/save", "POST", payload);

      const weblink = `https://web.dhundhoo.com/live_temp?apiKey=${generatedKey}&thingId=${linkTargetVehicle}`;  // 👈 changed
      setTempLink(weblink);
      setTempApiKey(generatedKey);

      setTimeout(() => setApiStep("success"), 100);
    } catch (err) {
      console.error(err);
    }
  };

const handleUpdateLink = async () => {
  if (!tempApiKey || !linkTargetVehicle) return;   // 👈 changed
  try {
    const duration = (parseInt(hours) || 0) * 60 + (parseInt(minutes) || 0);
    const payload = {
      thingId: linkTargetVehicle,        // 👈 changed
      tempApiKey: tempApiKey,
      expireTimeInMinutes: duration,
    };

    await apiCall("/tempUrl/update", "POST", payload);

    const weblink = `https://web.dhundhoo.com/live_temp?apiKey=${tempApiKey}&thingId=${linkTargetVehicle}`;
    setTempLink(weblink);

    setTimeout(() => setApiStep("success"), 100);
    openSnackbar("Temporary URL updated successfully");
  } catch (err) {
    openSnackbar(err.message || "Failed to update URL", "error");
  }
};

 const handleDeleteLink = async () => {
  if (!tempApiKey || !linkTargetVehicle) return; 
  try {
    const payload = {
      thingId: linkTargetVehicle,  
      tempApiKey,
    };

    await apiCall("https://camera.dhundhoo.com/tempUrl/delete", "POST", payload);
    alert("Link deleted!");
    setApiModalOpen(false);
  } catch (err) { }
};

  const handleDropdownOpen = () => {
    if (!searchQuery || searchQuery === lastFetchedId) return;

    dispatch(catchmentJourneyGetData(searchQuery));
    setLastFetchedId(searchQuery);
    dispatch(setSelectedJourneyId(""));
  };

  useEffect(() => {
    dispatch(setSelectedJourneyId(""));
  }, [searchQuery, dispatch]);

  const resetModal = () => {
    setApiStep("confirm");
    setHours(0);
    setMinutes(30);
    setTempLink("");
    setTempApiKey("");
    setLinkTargetVehicle(null);
  };

  const openSnackbar = (message, color = "success") => {
    setSnackbar({ open: true, message, color });
  };

  const openApiModal = (vehicleNumber, existingTempApiKey) => {
    resetModal();
    setLinkTargetVehicle(vehicleNumber);
    if (existingTempApiKey) {
      setTempApiKey(existingTempApiKey);
      setApiStep("time");
    }
    setApiModalOpen(true);
  };

  const vehicles = useMemo(() => {
    if (!responsedata || !responsedata.myThings) return [];

    const myThings = responsedata.myThings || {};
    const latestUpdates = responsedata.latestUpdates || {};
    const now = Date.now();

    return Object.entries(myThings)
      .map(([vehicleNumber, data]) => {
        const updateData = latestUpdates[vehicleNumber] || {};
        const latest = updateData?.latest?.GPS || updateData?.latest?.MOBILE || {};
        const raw = latest?.raw || {};
        const updatedAt = latest?.updatedAt || data?.latest?.MOBILE?.updatedAt || null;

        const imei =
          latest?.deviceId ||
          data?.latest?.MOBILE?.deviceId ||
          data?.deviceId ||
          "N/A";

        const journeyAvailable = data?.journeyAvailable === true;
        const journeyData = data?.currentJourney || {};
        const lastVisitedStopIndex = updateData?.lastVisitedStopIndex ?? 0;
        const stops = data?.stops || {};
        const totalStopsCount = Object.keys(stops).length;

        const progress = totalStopsCount > 0
          ? Math.min(Math.round((lastVisitedStopIndex / totalStopsCount) * 100), 100)
          : 0;

        const speed = parseFloat(latest?.speed ?? 0);
        const ignitionValue = latest?.raw?.IGNITION?.toString() ?? "";
        const isStale = updatedAt && (new Date(updatedAt).getTime() + 3600000 < now);


        return {
          vehicleNumber,
          nickName: data?.thing?.nickName || "N/A",
          name: data?.thing?.name || "N/A",
          imei,
          ignition: latest?.ignition ?? data?.latest?.MOBILE?.ignition ? "ON" : "OFF",
          ignitionRaw: ignitionValue,
          time: updatedAt ? new Date(updatedAt).toLocaleString("en-IN") : "N/A",
          rawTime: updatedAt ? new Date(updatedAt).getTime() : 0,
          speed: speed.toFixed(2),
          isStale,
          signal: raw?.SIGNAL_STRENGTH ? parseFloat(raw.SIGNAL_STRENGTH).toFixed() : "0.0",
          satellites: raw?.TOTAL_SATELLITE || 0,
          tempThing: data?.thing?.tempThing || null,
          tempApiKey: data?.thing?.tempApiKey || null,
          journeyAvailable,
          route: journeyAvailable ? `${journeyData?.journeyName || "N/A"}` : "N/A",
          status: `${lastVisitedStopIndex} / ${totalStopsCount}`,
          progress,
        };
      })
      .filter((vehicle) => {
        const q = (searchQuery || "").toLowerCase();
        const actualSearch = q.startsWith("@") ? "" : q;

        const matchesSearch = (vehicle.vehicleNumber || "").toLowerCase().includes(actualSearch) ||
          (vehicle.nickName || "").toLowerCase().includes(actualSearch) ||
          (vehicle.name || "").toLowerCase().includes(actualSearch);

        if (activeFilter === "@total") return matchesSearch;

        const speedNum = parseFloat(vehicle.speed);
        let matchesStatus = false;

        switch (activeFilter) {
          case "@offline":
            matchesStatus = vehicle.isStale;
            break;
          case "@running":
            matchesStatus = !vehicle.isStale && vehicle.ignitionRaw === "1" && speedNum >= 0.25;
            break;
          case "@idle":
            matchesStatus = !vehicle.isStale && vehicle.ignitionRaw === "1" && speedNum < 0.25;
            break;
          case "@parked":
            matchesStatus = !vehicle.isStale && vehicle.ignitionRaw === "0";
            break;
          case "@onroute":
            matchesStatus = vehicle.journeyAvailable;
            break;
          default:
            matchesStatus = true;
        }

        return matchesStatus && matchesSearch;
      })
      .sort((a, b) => b.rawTime - a.rawTime);
  }, [responsedata, searchQuery, activeFilter]);

  if (!responsedata || !responsedata.myThings) {
    return (
      <MDBox p={2}>
        <MDTypography variant="h6">Loading vehicle data...</MDTypography>
      </MDBox>
    );
  }

  const getVehicleStatusColor = (ignition, speed, rawTime) => {
    const now = Date.now();
    const isStale = rawTime && rawTime + 3600000 < now;
    if (isStale) return "secondary";
    if (ignition === "OFF") return "error.main";
    return parseFloat(speed) > 0 ? "success.main" : "warning.main";
  };

  const getSpeedStatusText = (ignition, speed, rawTime) => {
    const spd = parseFloat(speed);
    const now = Date.now();
    const isStale = rawTime && rawTime + 3600000 < now;
    if (isStale) return "Offline";
    if (ignition === "OFF" && spd === 0) return "Parked";
    if (ignition === "ON" && spd === 0) return "Idle";
    if (ignition === "ON" && spd > 0) return "Running";
    return "N/A";
  };

  const getSpeedTextColor = (ignition, speed, rawTime) => {
    const spd = parseFloat(speed);
    const now = Date.now();
    const isStale = rawTime && rawTime + 3600000 < now;
    if (isStale) return "secondary";
    if (ignition === "OFF" && spd === 0) return "error";
    if (ignition === "ON" && spd === 0) return "warning";
    if (ignition === "ON" && spd > 0) return "success";
    return "text";
  };

  // Signal strength (%) -> color: strong = green, moderate = orange, weak = red, offline = grey
  const getSignalColor = (signal, isStale) => {
    if (isStale) return "secondary"; // 👈 Offline par grey color

    const sig = parseFloat(signal);
    if (isNaN(sig)) return "text";
    if (sig >= 70) return "success";
    if (sig >= 40) return "warning";
    return "error";
  };

  // Satellite count -> color: good = green, weak = orange, poor = red, offline = grey
  const getSatelliteColor = (satellites, isStale) => {
    if (isStale) return "secondary"; // 👈 Offline par grey color

    const sats = parseFloat(satellites);
    if (isNaN(sats)) return "text";
    if (sats >= 10) return "success";
    if (sats >= 5) return "warning";
    return "error";
  };

  const handleEditJourneys = () => {
    if (searchQuery.trim() && !searchQuery.startsWith("@")) dispatch(setIsVehicle(searchQuery.trim()));
    navigate("/Create/Journey");
  };

  const handleAssignReplacement = () => {
    if (searchQuery.trim() && !searchQuery.startsWith("@")) dispatch(setIsVehicle(searchQuery.trim()));
    const thing = things.find((e) => e.id === searchQuery);
    dispatch(setModelThing(thing));
    dispatch(setModalVisible(true));
  };

  const handleEditDetails = () => {
    if (searchQuery.trim() && !searchQuery.startsWith("@")) dispatch(setIsVehicle(searchQuery.trim()));
    navigate("/Create/Edit-Details");
  };

  const handleNotificationLogs = () => {
    const vId = searchQuery.trim() && !searchQuery.startsWith("@") ? searchQuery.trim() : "";
    if (vId) dispatch(setIsVehicle(vId));
    navigate("/Reports/Notification-logs", { state: { autoFetchVehicleId: vId } });
  };

 const handleRouteReplay = () => {
    if (searchQuery.trim() && !searchQuery.startsWith("@")) {
      dispatch(setRouteReplayVehicle(searchQuery.trim()));
      dispatch(setAutoLoadRoute(true));
      navigate("/Route-Replay");
    }
  };

  const renderVehicleCard = (vehicle) => (
    <Card
      key={vehicle.vehicleNumber}
      sx={{
        mb: 2,
        p: 2,
        cursor: "pointer",
        "&:hover": { boxShadow: 3 },
      }}
      onClick={() => onVehicleSelect(vehicle.vehicleNumber)}
    >
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox display="flex" flexDirection="column" width="100%">
          <MDTypography
            variant="h6"
            fontWeight="medium"
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ flexWrap: "nowrap" }}
          >
            <DirectionsBusIcon
              fontSize="small"
              sx={{ color: getVehicleStatusColor(vehicle.ignition, vehicle.speed, vehicle.rawTime), flexShrink: 0 }}
            />
            <MDBox sx={{ minWidth: 0, flex: 1, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
              <MDTypography component="span" variant="body1" fontWeight="bold" sx={{ fontSize: "0.85rem" }}>
                {vehicle.nickName}
              </MDTypography>{" "}
              <MDTypography component="span" variant="body2" sx={{ fontSize: "0.75rem" }}>
                {vehicle.vehicleNumber}
              </MDTypography>
            </MDBox>

            <MDBox display="flex" alignItems="center" gap={1} sx={{ flex: "0 0 42%", flexShrink: 0, overflow: "hidden", whiteSpace: "nowrap" }}>
              {vehicle.tempThing && (
                <MDTypography fontWeight="small" fontSize="0.60rem" color="secondary">
                  Replacement{" "}
                  <MDTypography component="span" color="error" fontSize="0.60rem" fontWeight="bold">
                    {vehicle.tempThing}
                  </MDTypography>
                </MDTypography>
              )}

              <Tooltip title={vehicle.tempApiKey ? "Update Link" : "Create Link"}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    openApiModal(vehicle.vehicleNumber, vehicle.tempApiKey);
                  }}
                  sx={{ color: vehicle.tempApiKey ? "primary.main" : darkMode ? "#fff" : "text.secondary" }}
                >
                  <Icon fontSize="small">link</Icon>
                </IconButton>
              </Tooltip>

              {localStorage.getItem("isLiveCamera") === "true" && (
                <>
                  <Tooltip title="Live View">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        openLiveView(vehicle.vehicleNumber, vehicle.imei); // 👈 Yahan vehicle.imei add karo
                      }}
                      sx={{ color: "text.secondary" }}
                    >
                      <Icon fontSize="medium">videocam</Icon>
                    </IconButton>
                  </Tooltip>

                  {/* <Tooltip title="Playback History">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        openPlaybackView(vehicle.vehicleNumber);
                      }}
                     sx={{ color: "text.secondary" }}
                    >
                      <Icon fontSize="small">skip_previous</Icon>
                    </IconButton>
                  </Tooltip> */}

                  <Tooltip title="Playback History">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        openPlaybackView(vehicle.vehicleNumber, vehicle.imei); // 👈 Yahan vehicle.imei pass karo
                      }}
                      sx={{ color: "text.secondary" }}
                    >
                      <Icon fontSize="small">skip_previous</Icon>
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </MDBox>
          </MDTypography>

          <Divider sx={{ my: 1 }} />

          <MDBox display="flex" alignItems="center" justifyContent="space-between" width="100%" sx={{ flexWrap: "nowrap", gap: 1 }}>
            <MDTypography variant="button" color="text" sx={{ flex: 1, minWidth: 0, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
              {vehicle.time}
            </MDTypography>
            <MDTypography
              variant="button"
              color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)}
              fontWeight="medium"
              display="flex"
              alignItems="center"
              gap={0.5}
              sx={{ flex: "0 0 42%", flexShrink: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              <Icon fontSize="small">speed</Icon>
              {Math.round(vehicle.speed * 3.6).toFixed(2)} km/hr {getSpeedStatusText(vehicle.ignition, vehicle.speed, vehicle.rawTime)}
              {/* {(vehicle.speed * 3.6).toFixed(2)} km/hr {getSpeedStatusText(vehicle.ignition, vehicle.speed, vehicle.rawTime)} */}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" alignItems="center" justifyContent="space-between" width="100%" sx={{ flexWrap: "nowrap", gap: 1 }} mt={1}>
            <MDBox display="flex" alignItems="center" gap={2} sx={{ minWidth: 0, overflow: "hidden", flexShrink: 1 }}>
              <MDTypography variant="button" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)} display="flex" alignItems="center" gap={0.5} sx={{ whiteSpace: "nowrap" }}>
                <Icon fontSize="small" color={getSpeedTextColor(vehicle.ignition, vehicle.speed, vehicle.rawTime)}>vpn_key</Icon>
                Ignition {vehicle.ignition}
              </MDTypography>
              <MDTypography variant="button" color={getSignalColor(vehicle.signal, vehicle.isStale)} display="flex" alignItems="center" gap={0.5} sx={{ whiteSpace: "nowrap" }}>
                <Icon fontSize="small" color={getSignalColor(vehicle.signal, vehicle.isStale)}>signal_cellular_alt</Icon> Signal {vehicle.signal}%
              </MDTypography>
            </MDBox>

            {/* 👇 Satellite UI updated with vehicle.isStale */}
            <MDTypography variant="button" color={getSatelliteColor(vehicle.satellites, vehicle.isStale)} display="flex" alignItems="center" gap={0.5} sx={{ flex: "0 0 42%", flexShrink: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <Icon fontSize="small" color={getSatelliteColor(vehicle.satellites, vehicle.isStale)}>satellite_alt</Icon> Satellites {vehicle.satellites}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>

      {selectedVehicleNumber !== undefined && searchQuery === vehicle.vehicleNumber && (
        <MDBox sx={{ padding: 1 }}>
          {/* <Select
            value={selectedJourneyId}
            onOpen={handleDropdownOpen}
            onChange={(e) => dispatch(setSelectedJourneyId(e.target.value))}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) return "Select and plot journey route on map";
              const j = journeys.find((item) => item.journeyId === selected);
              return j ? j.journeyName : "Select Journey";
            }}
            sx={{ width: "100%", mb: 2, p: 1, fontSize: "0.875rem" }}
          >
            {loadingJourneys ? (
              <MenuItem disabled><MDTypography variant="button">Loading...</MDTypography></MenuItem>
            ) : journeys.length === 0 ? (
              <MenuItem disabled><MDTypography variant="button">No journeys found</MDTypography></MenuItem>
            ) : (
              journeys.map((item) => (
                <MenuItem key={item.journeyId} value={item.journeyId}>
                  <MDBox display="flex" flexDirection="column">
                    <MDTypography variant="button" fontWeight="bold">{item.journeyName}</MDTypography>
                    <MDTypography variant="caption" color="text">{item.type} - {item.startTime}</MDTypography>
                  </MDBox>
                </MenuItem>
              ))
            )}
          </Select> */}

          <MDBox sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {/* <Button variant="outlined" size="small" onClick={handleNotificationLogs} sx={{ fontWeight: 400, fontSize: "0.75rem", padding: "4px 10px", border: "1px solid #ccc", color: darkMode ? "#fff" : "rgb(102, 102, 102)" }}>
              Notification Logs
            </Button> */}
            <Button variant="outlined" size="small" onClick={handleRouteReplay} sx={{ fontWeight: 400, fontSize: "0.75rem", padding: "4px 10px", border: "1px solid #ccc", color: darkMode ? "#fff" : "rgb(102, 102, 102)" }}>
              Route Replay
            </Button>
            <Button variant="outlined" size="small" onClick={handleEditDetails} sx={{ fontWeight: 400, fontSize: "0.75rem", padding: "4px 10px", border: "1px solid #ccc", color:darkMode ? "#fff" : "rgb(102, 102, 102)" }}>
              Edit Details
            </Button>
            {/* <Button variant="outlined" size="small" onClick={handleEditJourneys} sx={{ fontWeight: 400, fontSize: "0.75rem", padding: "4px 10px", border: "1px solid #ccc", color:darkMode ? "#fff" : "rgb(102, 102, 102)" }}>
              Edit Journeys
            </Button> */}
            {/* <Button variant="outlined" size="small" onClick={handleAssignReplacement} sx={{ fontSize: "0.75rem", padding: "4px 10px", color: thempThing.tempThing ? "red" : darkMode ? "#fff" : "rgb(102, 102, 102)", border: thempThing.tempThing ? "1px solid red" : "1px solid #ccc" }}>
              {thempThing.tempThing ? "Remove Replacement" : "Assign Replacement"}
            </Button> */}

            {vehicle.tempApiKey && (
              <Button variant="outlined" size="small" color="error" startIcon={<Icon fontSize="small">delete</Icon>} sx={{ fontSize: "0.75rem", padding: "4px 10px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setLinkTargetVehicle(vehicle.vehicleNumber);
                  setTempApiKey(vehicle.tempApiKey);
                  setApiStep("delete");
                  setApiModalOpen(true);
                }}
              >
                Delete Link
              </Button>
            )}
          </MDBox>
        </MDBox>
      )}

      {/* {vehicle.journeyAvailable ? (
        <>
          <Divider sx={{ my: 1 }} />
          <MDTypography variant="button" fontWeight="medium" color="text">
            On Route <strong>{vehicle.route}</strong>
          </MDTypography>
          <MDTypography variant="button" color={vehicle.isStale ? "secondary" : "success"}>
            Status: {vehicle.status}
          </MDTypography>
          <MDBox mt={1}>
            <div style={{ width: '100%', backgroundColor: '#f0f2f5', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
              <div style={{ width: `${vehicle.progress}%`, backgroundColor: '#4caf50', height: '100%', borderRadius: '4px', transition: 'width 0.5s ease-in-out' }} />
            </div>
          </MDBox>
        </>
      ) : (
        <Divider sx={{ my: 1 }} />
      )} */}
    </Card>
  );

  return (
    <MDBox
      pb={3}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {vehicles.map(renderVehicleCard)}

      <Dialog
        open={apiModalOpen}
        onClose={() => { if (!loading) setApiModalOpen(false); }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {apiStep === "confirm" && "Create API Key"}
          {apiStep === "time" && (tempApiKey ? "Update Link" : "Select Expiry Time")}
          {apiStep === "success" && "Link Generated"}
          {apiStep === "delete" && "Delete Temp URL Link"}
          <IconButton onClick={() => setApiModalOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}>
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {apiStep === "confirm" && <MDTypography>Are you sure you want to create an API key?</MDTypography>}

          {apiStep === "time" && (
            <MDBox display="flex" alignItems="center" gap={2} flexWrap="wrap">
              <Select value={hours} onChange={(e) => setHours(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
                {[...Array(25)].map((_, i) => <MenuItem key={i} value={i}>{i} hours</MenuItem>)}
              </Select>
              <Select value={minutes} onChange={(e) => setMinutes(e.target.value)} sx={{ minWidth: 120, height: 40 }}>
                {Array.from({ length: 60 }, (_, i) => <MenuItem key={i} value={i}>{i} minutes</MenuItem>)}
              </Select>
              <Button
                variant="contained"
                disabled={loading}
                onClick={async (e) => {
                  e.preventDefault(); e.stopPropagation();
                  if (loading) return;
                  try {
                    if (tempApiKey) await handleUpdateLink();
                    else await handleCreateLink();
                  } catch (err) { console.error(err); }
                }}
                sx={{ background: "#FB8C00", color: "#fff", minWidth: 120, height: 40, "&:hover": { background: "#ef6c00" } }}
              >
                {loading ? "Please Wait..." : "Confirm"}
              </Button>
            </MDBox>
          )}

          {apiStep === "success" && (
            <MDBox>
              <MDTypography variant="body2">Generated Link:</MDTypography>
              <MDBox sx={{ bgcolor: "#f5f5f5", p: 1.5, borderRadius: 1, wordBreak: "break-all", fontFamily: "monospace" }}>
                {tempLink}
              </MDBox>
              <MDBox display="flex" gap={1} mt={2}>
                <Button variant="contained" startIcon={<Icon>content_copy</Icon>} onClick={() => { navigator.clipboard.writeText(tempLink); openSnackbar("Copied!"); }} style={{ background: "#FB8C00", color: 'white' }}>Copy</Button>
                <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: "#FB8C00", color: 'white' }}>Update</Button>
                <Button variant="contained" color="error" onClick={() => setApiStep("delete")} style={{ background: "#FB8C00", color: 'white' }}>Delete</Button>
              </MDBox>
            </MDBox>
          )}

          {apiStep === "delete" && <MDTypography color="error">Are you sure you want to delete this temporary link?</MDTypography>}
        </DialogContent>

        <DialogActions>
          {apiStep === "confirm" && (
            <>
              <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
              <Button variant="contained" onClick={() => setApiStep("time")} style={{ background: '#FB8C00', color: 'white' }}>OK</Button>
            </>
          )}
          {apiStep === "delete" && (
            <>
              <Button onClick={() => setApiModalOpen(false)}>Cancel</Button>
              <Button variant="contained" color="error" onClick={handleDeleteLink}>Delete</Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* 👇 RENDER THE NEW LIVE CAMERA MODAL COMPONENT */}
      <LiveCameraModal
        open={streamModalOpen}
        onClose={() => setStreamModalOpen(false)}
        vehicleId={currentVehicleForStream}
        imei={currentImeiForStream}
        sessionToken={sessionToken}
      />

      <PlaybackHistoryModal
        open={playbackModalOpen}
        onClose={() => setPlaybackModalOpen(false)}
        vehicleId={currentVehicleForPlayback}
        imei={currentImeiForPlayback}
        sessionToken={sessionToken}
      />

    </MDBox>
  );
}

Projects.propTypes = {
  onVehicleSelect: PropTypes.func,
};

export default Projects;